module.exports = __webpack_public_path__ + "media/1x1/gb-nir-9cad35c4.svg";